export const CTA_SECTION_TITLE = "עדיין לא מכירים את הדיירים שלכם?"
